export const MODULOR_FONTS = {
  TITLE_1_BOLD: 'title-1-bold',
  TITLE_1_SEMIBOLD: 'title-1-semibold',

  TITLE_2_SEMIBOLD: 'title-2-semibold',
  TITLE_2_REGULAR: 'title-2-regular',

  CAPTION_1_REGULAR: 'caption-1-regular',
  CAPTION_1_REGULAR_CAPS: 'caption-1-regular-caps',
  CAPTION_2_MEDIUM: 'caption-2-medium',
  CAPTION_2_MEDIUM_CAPS: 'caption-2-medium-caps',
  CAPTION_3_SEMIBOLD: 'caption-3-semibold',

  SUBHEAD_REGULAR: 'subhead-regular',
  SUBHEAD_SEMIBOLD: 'subhead-semibold',

  BODY_SEMIBOLD: 'body-semibold',
  BODY_REGULAR: 'body-regular',
  BODY_ROUNDED_MEDIUM: 'body-rounded-medium',

  LARGE_TITLE_SEMIBOLD: 'large-title-semibold',
  LARGET_TITLE_HEAVY: 'large-title-heavy',
};
